import { ParticleBackground as SharedParticleBackground } from "@dolfin/ui";
import { useTheme } from "./ThemeProvider";

export function ParticleBackground({ prominent = false }: { prominent?: boolean }) {
  const { theme } = useTheme();
  return <SharedParticleBackground theme={theme} prominent={prominent} />;
}
